<div>
    <app-alert *ngIf="(smsAlert$ | async) as smsAlert" [level]="smsAlert.level" [message]="smsAlert.message"></app-alert>
    <app-sms-create *ngIf="!inComplianceReview" [borrower]="borrower" (newSms)="handleSubmitSms($event)"></app-sms-create>
    <div *ngIf="showHistory" style="margin-top: 50px;">
        <div class="spinner-container" *ngIf="(loadingInitial$ | async) === true">
          <mat-spinner></mat-spinner>
        </div>

        <app-transcript [messages]="transcriptMessages$ | async"></app-transcript>
    </div>

  <div *ngIf="(transcriptMessages$ | async)?.length === 15" class="text-center">
    <div *ngIf="!((loadingAll$ | async) === false && (transcriptMessages$ | async)?.length === 15 && disableLoadAll)">
      <div class="date-group">
        <div class="my-3 position-relative">
          <hr class="w-100 position-absolute h-50 m-0 message-divider" />
          <div class="text-center">
            <span class="bg-white px-4">
              <button mat-flat-button
                      [disabled]="disableLoadAll"
                      class="newstd-btn newstd-btn-default mat-elevation-z4 mat-focus-indicator mat-flat-button mat-button-base"
                      (click)="loadAllMessages()">
                Load All
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="spinner-container" *ngIf="(loadingAll$ | async) === true">
      <mat-spinner></mat-spinner>
    </div>

    <div class="text-center" *ngIf="(loadingAll$ | async) === false && (transcriptMessages$ | async)?.length === 15 && disableLoadAll">
      Showing all messages.
    </div>
  </div>
</div>
